export default "__VITE_ASSET__BBRlgIO4__"